export interface Recruiter {
  name: string;
}

export const pastRecruiters: Recruiter[] = [
  // A
  { name: "Akash Byju's" },
  { name: "Accenture" },
  { name: "Addverb Technologies" },
  { name: "Aditya Birla Capital" },
  { name: "Ahana IT" },
  { name: "Algomox Pvt. Ltd." },
  { name: "AlgoUniversity" },
  { name: "Allgovision" },
  { name: "AltiusHub" },
  { name: "Amazon" },
  { name: "Amazon (Prime)" },
  { name: "Amuse Labs" },
  { name: "Antino Labs Pvt. Ltd" },
  { name: "Apnamart" },
  { name: "AquaAirX" },
  { name: "Atlas Consolidated Pte Ltd" },
  { name: "Atlassian" },
  { name: "Axcess.io" },

  // B
  { name: "BeeHyv Software Soutions Pvt.Ltd" },
  { name: "Bhanzu" },
  { name: "BigHaat" },
  { name: "BlogVault" },
  { name: "Bosch Global Software Technologies" },

  // C
  { name: "Capgemini" },
  { name: "Care Health Insurance Limited" },
  { name: "C-DACC-DOT" },
  { name: "Center for Geo-spatial Analytics and Cartography (CGAC)" },
  { name: "CGI" },
  { name: "CodeHall Technology Pvt Ltd." },
  { name: "Cognizant" },
  { name: "Cogoport" },
  { name: "CoinSwitch" },
  { name: "Computer Age Management Services Limited" },
  { name: "Comviva" },
  { name: "ConcertAI" },
  { name: "Corizo" },
  { name: "Covalense Technologies Private Limited" },
  { name: "Creencia" },
  { name: "Cresen Solutions" },
  { name: "Cyfuture India Pvt. Ltd." },

  // D
  { name: "DataInsights" },
  { name: "Deloitte" },
  { name: "DeltaX" },
  { name: "Demand Farm" },
  { name: "DigiXL" },
  { name: "TDRO" },
  { name: "Dvara Solutions" },
  { name: "Dyeus" },

  // E
  { name: "Edfora" },
  { name: "ElectricPe" },
  { name: "Engineer's Cradle" },
  { name: "Ericsson India Global Services" },
  { name: "Eshopbox" },
  { name: "Esteco" },
  { name: "Evertz" },
  { name: "ExcelR Edtech Pvt. Ltd." },
  { name: "Exiger Technologies" },
  { name: "Expand My Business" },

  // F
  { name: "Face Prep" },
  { name: "FIS University" },
  { name: "FiveS Digital" },
  { name: "Fleetx.io" },
  { name: "Flipr" },
  { name: "Frugal Testing" },

  // G
  { name: "GlowLogics Solutions Pvt Ltd" },
  { name: "GoVivace Inc." },
  { name: "GrayQuest" },
  { name: "GreedyGame" },
  { name: "Growth Jockey Private Limited" },

  // H
  { name: "HashedIn Technologies" },
  { name: "Hexaware" },
  { name: "HP" },
  { name: "Human Resocia" },

  // I
  { name: "IBM" },
  { name: "Ielektron Technologies" },
  { name: "IIT Roorkee" },
  { name: "Increff" },
  { name: "Incture" },
  { name: "IndiaMart" },
  { name: "Indian School of Development Management" },
  { name: "Info Edge India Limited" },
  { name: "Infokalash" },
  { name: "Infosys" },
  { name: "Intel India" },
  { name: "Intellipaat" },
  { name: "Internzvalley" },
  { name: "IntrnForte" },
  { name: "Ipsos Research Private Limited" },

  // J
  { name: "Josh Technology Group" },

  // K
  { name: "K12 Techno Services Pvt Ltd" },
  { name: "Knoldge Foundry" },
  { name: "Kodnest - Fluence" },
  { name: "Kodnest - Recruit CRM" },
  { name: "KodNest Technologies" },
  { name: "Krutanic Solutions" },

  // L
  { name: "Lila Games" },
  { name: "Loyalty Juggernaut Inc" },
  { name: "LYBL" },

  // M
  { name: "Mahindra & Mahindra" },
  { name: "MAQ Software" },
  { name: "MathCo" },
  { name: "Maximl" },
  { name: "Medicodio" },
  { name: "MoneyyApp" },
  { name: "Motive India" },
  { name: "mthree" },
  { name: "Mu Sigma" },
  { name: "MyCaptain" },
  { name: "MyWays" },
  { name: "MyWays.ai" },

  // N
  { name: "Nagarro" },
  { name: "NexTurn India Private Limited" },
  { name: "Ninjacart" },
  { name: "NTT DATA" },
  { name: "Numeric Technologies (India) Pvt Ltd" },
  { name: "Nvidia" },
  { name: "NxtWave" },
  { name: "NxtWave - Lloyds Technology Centre" },
  { name: "NxtWave (ThoughtWorks)" },

  // O
  { name: "Oracle" },
  { name: "Oracle Financial Software Services Ltd." },
  { name: "Outlook Group" },

  // P
  { name: "Patenti Technology Solutions" },
  { name: "Pigeon Education Technology - ODA Class" },
  { name: "Placewit" },
  { name: "Planetspark" },
  { name: "Plungin live - Smartavya Analytics" },
  { name: "Polycab" },
  { name: "Primera Medical Technologies" },
  { name: "ProGrad" },
  { name: "Prolexera" },
  { name: "Publicis Sapient" },
  { name: "Pyzaql" },

  // Q
  { name: "Qbit Labs" },
  { name: "Qbits Learning" },
  { name: "QubicGen Software Solutions Pvt. Ltd" },

  // R
  { name: "R Systems International Limited" },
  { name: "Recruit CRM" },
  { name: "Redseer Strategy Consultants" },
  { name: "Ridiv Technologies" },

  // S
  { name: "Salesforce" },
  { name: "ScaleKNOT" },
  { name: "Semifront Technologies Private Limited" },
  { name: "Shopconnect - nVipani Technology" },
  { name: "Shopconnect.live" },
  { name: "Siemens" },
  { name: "SkillBuz" },
  { name: "SoCtronics" },
  { name: "Structured" },
  { name: "Supaki Inc" },
  { name: "Sustainability Economics" },
  { name: "Swiggy" },
  { name: "SymphonyAI" },
  { name: "Synapse Techno Design Innovations Pvt Ltd" },

  // T
  { name: "TalentServe" },
  { name: "Tata iQ" },
  { name: "Tata Motors Limited" },
  { name: "TCS" },
  { name: "Tech Mahindra" },
  { name: "Techolution" },
  { name: "Tejas Networks" },
  { name: "TensorGo Software Pvt Ltd" },
  { name: "Tesca Technologies Pvt. Ltd." },
  { name: "Tesco" },
  { name: "The Jurni" },
  { name: "ThirdEye Data" },
  { name: "ThoughtFocus Technologies Pvt. Ltd." },
  { name: "Thrillophilia" },
  { name: "Trilogy Innovations" },

  // U
  { name: "UKG (Ultimate Kronos Group)" },

  // V
  { name: "Vegam Solutions" },
  { name: "Vibrant Minds - Coditas Solutions" },

  // W
  { name: "Warden" },
  { name: "Weskill" },
  { name: "Workruit" },
  { name: "Wyreflow Technologies" },

  // Y
  { name: "Yhills Edutech" },

  // Z
  { name: "Zscaler" },
];
